export default "__VITE_ASSET__DIfLPTHi__"